import { Text } from "@certn/cascadia";
import { Section } from "@certn/cascadia-react";

import { RenderContext } from "@certn/cascadia-react/context/RenderContext";
import { slugify } from "@certn/utils";
import { css } from "@emotion/css";
import { ControlElement, ControlProps } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsControlProps } from "@jsonforms/react";
import { useContext, useState } from "react";
import {
  ExpandCollapseAll,
  showExpandCollapseAllControl,
} from "../components/ExpandCollapseAll";

function convertTestId(title: string) {
  const title_without_count = title.replace(/[^A-Za-z\s]+/gi, "");
  return slugify(title_without_count.trim());
}

export function AccordionContainer(props: ControlProps) {
  const options = props.uischema.options || {};
  const [isOpen, setIsOpen] = useState(options.initialState === true || false);
  const [hasToggledAll, setHasToggledAll] = useState(false);
  const [toggleAllRevision, setToggleAllRevision] = useState(0);
  const isPDF = useContext(RenderContext).isForPdfGeneration;

  const setExpandCollapseAll = (open: boolean) => {
    setHasToggledAll(true);
    setIsOpen(open);
    setToggleAllRevision((revision) => revision + 1);
  };

  if (!props.visible) {
    return null;
  }

  return (
    <div
      data-testid="accordion-container"
      className={styles.accordionContainer}
    >
      {(options.heading || showExpandCollapseAllControl(isPDF, options)) && (
        <div className={styles.headingContainer}>
          {options.heading && (
            <Text style={options.headingStyle}>{options.heading}</Text>
          )}
          <ExpandCollapseAll
            isOpen={isOpen}
            setIsOpen={setExpandCollapseAll}
            options={options}
          />
        </div>
      )}

      {options.detail.elements.map((elem: ControlElement, index: number) => {
        const title = elem.label ? elem.label.toString() : "";
        const sectionInitialState =
          elem.options && "initialState" in elem.options
            ? Boolean(elem.options.initialState)
            : isOpen;
        const sectionOpen =
          isPDF || (hasToggledAll ? isOpen : sectionInitialState);
        return (
          <Section
            key={`${index}-${toggleAllRevision}`}
            isOpen={sectionOpen}
            data={
              <JsonFormsDispatch
                key={index}
                schema={props.schema}
                uischema={elem}
                path={props.path}
              />
            }
            title={title}
            testID={`section-${convertTestId(title)}`}
          />
        );
      })}
    </div>
  );
}

const styles = {
  accordionContainer: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-6)",
  }),
  headingContainer: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }),
};

export const AccordionContainerRenderer =
  withJsonFormsControlProps(AccordionContainer);
